import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=3a5090aa&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=3a5090aa&prod&lang=css"
import style1 from "./Products.vue?vue&type=style&index=1&id=3a5090aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5090aa",
  null
  
)

export default component.exports